import actionCreatorFactory from 'typescript-fsa';
import { UseCaseAccounting } from '../../../services/account';
import { ServerType } from '../../System/systemConfig';

const actionCreator = actionCreatorFactory();

export const SYSADMIN_LOAD_USE_CASE_LOGS = 'SYSADMIN_LOAD_USE_CASE_LOGS';
export const sysadminLoadUseCaseLogs = actionCreator<ServerType>(SYSADMIN_LOAD_USE_CASE_LOGS);

export const SYSADMIN_CLEAR_USE_CASE_LOGS = 'SYSADMIN_CLEAR_USE_CASE_LOGS';
export const sysadminClearUseCaseLogs = actionCreator<ServerType>(SYSADMIN_CLEAR_USE_CASE_LOGS);

export interface UseCaseLogRequest {
    server: ServerType;
    useCaseLogs: UseCaseAccounting[];
}
export const SYSADMIN_SET_USE_CASE_LOGS = 'SYSADMIN_CLSYSADMIN_SET_USE_CASE_LOGSEAR_USE_CASE_LOGS';
export const sysadminSetUseCaseLogs = actionCreator<UseCaseLogRequest>(SYSADMIN_SET_USE_CASE_LOGS);